import { isAnyOf } from '@reduxjs/toolkit';
import { actionSend } from '@skynet/data-ws-mm';
import { actionEsSend } from '@skynet/data-ws-es';
import { ensureAccessToken, selectAccessToken } from '@skynet/data-auth-api';
import { addPreAppMiddleware } from './dynamicMiddleware';

addPreAppMiddleware((store) => (next) => async (action) => {
  if (isAnyOf(actionSend, actionEsSend)(action)) {
    const state = store.getState();
    const accessToken = selectAccessToken(state);
    const ensured = await ensureAccessToken(store, accessToken);
    if (ensured) {
      return next(action);
    }
    return null;
  }
  return next(action);
});
